import { useCallback, useRef } from "react";

const DEFAULT_HOLD_MS = 5000;

export function useTripleTouch({
  onTripleTouch,
  holdDuration = DEFAULT_HOLD_MS,
} = {}) {
  const holdTimer = useRef(null);
  const holding = useRef(false);

  const clearHold = useCallback(() => {
    if (holdTimer.current) {
      clearTimeout(holdTimer.current);
      holdTimer.current = null;
    }
    holding.current = false;
  }, []);

  const startHold = useCallback(() => {
    if (holding.current) return;
    holding.current = true;
    holdTimer.current = setTimeout(() => {
      holdTimer.current = null;
      holding.current = false;
      onTripleTouch?.();
    }, holdDuration);
  }, [holdDuration, onTripleTouch]);

  const handleTouchStart = useCallback(
    (event) => {
      if (event.touches.length === 3) {
        startHold();
        return;
      }
      clearHold();
    },
    [clearHold, startHold]
  );

  const handleTouchEnd = useCallback(
    (event) => {
      if (event.touches.length !== 3) clearHold();
    },
    [clearHold]
  );

  const handleTouchMove = useCallback(
    (event) => {
      if (event.touches.length !== 3) clearHold();
    },
    [clearHold]
  );

  const reset = useCallback(() => {
    clearHold();
  }, [clearHold]);

  return { handleTouchStart, handleTouchEnd, handleTouchMove, reset };
}
